<mat-accordion>
  <mat-expansion-panel [expanded]="displayForm">
    <mat-expansion-panel-header (click)="toggleRateInquiryForm()">
      <mat-panel-title>
        Rate Inquiry Form
      </mat-panel-title>
      <mat-panel-description class="justify-content-end">
        <strong class="d-flex align-items-center">
          <mat-icon class="h-auto" fontSet="fas" fontIcon="fa-filter"></mat-icon>
          {{ displayForm ? 'Hide' : 'Show' }} Form
        </strong>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="row justify-content-end">
      <div class="col-sm-12 col-md-9 col-lg-6 py-3">
        <ng-favorites-container #favorites [applicationType]="applicationType" (favoritesSelected)="favoritesSelected($event)"
                                (savedFavorite)="favoriteSaved($event)" (updatedFavorite)="favoriteSaved($event)">
        </ng-favorites-container>
      </div>
    </div>
    <form [formGroup]="searchRateInquiryForm">
      <div class="d-flex flex-column h-100">
        <div class="row pb-3">
          <div class="col-lg-2 col-md-4">
            <ns-autocomplete (selected)="autocompleteSelected('originCity', 'originState')" [data]="states"
                             [formCtrl]="searchRateInquiryForm.controls.originState" label="Origin State" ngSpecialCharacter type="grouped"
                             [isRequired]="true" [filterByKeyAndValue]="true">
            </ns-autocomplete>
          </div>
          <div class="col-lg-2 col-md-4">
            <ns-autocomplete [data]="originStations" [filter]=false [formCtrl]="searchRateInquiryForm.controls.originCity" label="Origin Station"
                             ngSpecialCharacter type="simple" [isLoading]="isLoadingOS" [isRequired]="true">
            </ns-autocomplete>
          </div>
          <div class="col-lg-2 col-md-4">
            <ns-autocomplete (selected)="autocompleteSelected('destinationCity', 'destinationState')" [data]="states"
                             [formCtrl]="searchRateInquiryForm.controls.destinationState" label="Destination State" ngSpecialCharacter type="grouped"
                             [isRequired]="true" [filterByKeyAndValue]="true">
            </ns-autocomplete>
          </div>
          <div class="col-lg-2 col-md-4">
            <ns-autocomplete [data]="destinationStations" [filter]=false [formCtrl]="searchRateInquiryForm.controls.destinationCity"
                             label="Destination Station" ngSpecialCharacter type="simple" [isLoading]="isLoadingDS" [isRequired]="true">
            </ns-autocomplete>
          </div>
          <div class="col-lg-4 col-md-4">
            <ns-autocomplete (selected)="autocompleteSelected('carType', 'stcc')" [data]="stccList" [filter]=false
                             [formCtrl]="searchRateInquiryForm.controls.stcc" label="STCC" ngSpecialCharacter type="simple"
                             [isLoading]="isLoadingStcc" [isRequired]="true">
            </ns-autocomplete>
          </div>
          <div class="col-lg-2 col-md-4" *ngIf="isMediumViewport">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Car Type</mat-label>
              <mat-select [compareWith]="carTypeComparator" aria-label="Car Type" formControlName="carType">
                <mat-option [value]="defaultCarTypeOption">
                  {{ defaultCarTypeOption.value }}
                </mat-option>
                <mat-option *ngFor="let element of carTypes" [value]="element">
                  {{ element.value }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="searchRateInquiryForm.get('carType')?.hasError('required')">
                Please choose a car type
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-4" *ngIf="!isMediumViewport">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Car Type</mat-label>
              <mat-select [compareWith]="carTypeComparator" aria-label="Car Type" formControlName="carType">
                <mat-option [value]="defaultCarTypeOption">
                  {{ defaultCarTypeOption.value }}
                </mat-option>
                <mat-option *ngFor="let element of carTypes" [value]="element">
                  {{ element.value }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="searchRateInquiryForm.get('carType')?.hasError('required')">
                Please choose a car type
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-2 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Car Owner</mat-label>
              <mat-select [compareWith]="carOwnerComparator" aria-label="Car Owner" formControlName="carOwner">
                <mat-option [value]="defaultCarOwnerOption">
                  {{ defaultCarOwnerOption.value }}
                </mat-option>
                <mat-option *ngFor="let element of carOwners" [value]="element">
                  {{ element.value }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="searchRateInquiryForm.get('carOwner')?.hasError('required')">
                Please choose a car owner
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <input aria-label="Publication" formControlName="publication" matInput ngSpecialCharacter placeholder="Publication" ngTrim>
              <mat-error *ngIf="searchRateInquiryForm.get('publication')?.hasError('pattern')">
                Please enter a valid Publish Authority and Authority Number
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-2 col-md-4 my-4">
            <mat-checkbox aria-label="Rule 11" class="w-100" formControlName="rule11">Rule 11</mat-checkbox>
          </div>
        </div>
      </div>
    </form>
    <mat-action-row>
      <div class="d-flex justify-content-end">
        <button (click)="updateSearchList()" [disabled]="isValidUpdateButton()" aria-label="Update Search" class="my-2" color="accent"
                mat-flat-button [matTooltip]="selectedInquiry ? 'Save to Search List' : 'Add to Search List'">
          {{ selectedInquiry ? 'Save to Search List' : 'Add to Search List' }}
        </button>
        <button (click)="clearSearchForm()" aria-label="Clear" class="my-2" color="warn" mat-stroked-button matTooltip="Reset Inquiry Form">
          Clear
        </button>
        <button (click)="search()" [disabled]="isValidUpdateButton()" aria-label="Search" class="my-2" color="accent"
                mat-flat-button matTooltip="Search">
          Search
        </button>
        <button (click)="newInquiry()" aria-label="New Inquiry" class="my-2" color="accent" mat-flat-button matTooltip="Reset Form and Clear Inquiry">
          New Inquiry
        </button>
      </div>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
